import { tools } from "@/assets/js/SDK_copy/libs/sdk.tools";

import axios from "axios";

const { log } = console;
let kksa_imported = false;
let init_kksa_type = false; // 埋点sdk是都加载完成

//通用属性		
let common_default = {		
    TriggerPage: tools.urlValue().origin || "HomePage",		
    H5Page: location.href,		
};

function returnTrackPlatform() {		
    let ua = window.__gvalkkmh.ua;		
    if (ua.kkmh) return "客户端";		
    return ua.weixin ?		
        "微信" : ua.qqnative ?		
            "QQ" : ua.weibo ?		
                "微博" : ua.qq ?		
                    "QQ浏览器" : ua.alipay ?		
                        "支付宝" : "其他";		
}

function isKuaikanApp() {
    var userAgent = navigator.userAgent.toLowerCase();
    return /kuaikan\//.test(userAgent);
}
// 动态引入kksa
function importKksa() {
    // 因为BeMembershipResult 只能上报的app 所以为了查询方便其他的也上报的 app。
    // 因此 端外一定要注意 获取到uid才能上报
    const gloalInfo = window.__gvalkkmh;

    if (isKuaikanApp()) {
        return import("@/assets/js/common/kksa_kuaikanapp.js").then(() => {
            return Promise.resolve({ code: 200, message: "[import kksa_kuaikanapp success]" });
        }).catch(() => {
            return Promise.reject({ code: 400, message: "[import kksa_kuaikanapp failed]" });
        });
    } else {
        if (gloalInfo.user.id != 0 && gloalInfo.user.id != undefined) {
            return import("@/assets/js/common/kksa_kuaikanapp.js").then(() => {
                return Promise.resolve({ code: 200, message: "[import kksa_kuaikanapp success]" });
            }).catch(() => {
                return Promise.reject({ code: 400, message: "[import kksa_kuaikanapp failed]" });
            });
        } else {
            return import("@/assets/js/common/kksa_default.js").then(() => {
                return Promise.resolve({ code: 200, message: "[import kksa_default success]" });
            }).catch(() => {
                return Promise.reject({ code: 400, message: "[import kksa_default failed]" });
            });
        }
    }
}
//上报
function doTrack(event, prototype) {

    if (!kksa_imported) {
        importKksa().then(res => {
            const { code, message } = res;
            log(message);
            if (code == 200) {
                kksa_imported = true;
                track();
            }
        });
    } else {
        track();
    }

    async function track() {
        if (!setCanTrack()) {
            log("未获取到uid或设备Id或openid，不进行埋点上报");
            return false;
        }
        await kksaIdentify();
        log(event, prototype);

        if (init_kksa_type) {
            kksa.track(event, prototype);
        } else {
            let tiem = setTimeout(() => {
                clearTimeout(tiem);
                init_kksa_type = true;
                kksa.track(event, prototype);
            }, 1000);
        }
        // kksa.track(event, prototype)
    }
}
//能否上报
function setCanTrack() {
    const gloalInfo = window.__gvalkkmh;
    const isMini = gloalInfo.ua.miniprogram;
    if (isKuaikanApp()) {
        // 端内
        return gloalInfo.user.id != undefined || !!gloalInfo.sys.device_id;
    } else if (isMini) {
        // 小程序内
        let miniId = getMiniId();
        return !(miniId["uid"] == "" && miniId["open_id"] == "");
    } else {
        // 端外浏览器中
        // return gloalInfo.user.id != 0 && gloalInfo.user.id != undefined
        return true;
    }
}
// 小程序中获取uid，openid
function getMiniId() {
    let kkid = tools.urlValue()["kkid"] || "";
    kkid = decodeURIComponent(kkid);
    let uid = kkid.split("#")[1] || "";
    let open_id = (kkid.split(":")[1] || "").split("#")[0] || "";

    return {
        uid,
        open_id
    };
}
// kksa上报初始化
async function kksaIdentify() {
    const gloalInfo = window.__gvalkkmh;
    const isMini = gloalInfo.ua.miniprogram;

    // NOTICE:初始化的id必须是字符串
    if (isKuaikanApp()) {
        const uid = gloalInfo.user.id || 0;
        const device_id = gloalInfo.sys.device_id;
        const uid_str = uid.toString();
        if (uid != 0 && uid != undefined) {
            kksa.identify(uid_str);
        } else {
            kksa.identify(device_id);
        }
    } else if (isMini) {
        const uid = getMiniId()["uid"];
        const open_id = getMiniId()["open_id"];
        kksa.identify(uid || open_id);
    } else {
        await axios({
            method: "get",
            url: "/v2/passport/user/me",
        }).then(res => {
            res = res.status ? res.data : res;
            if (res.code === 200 ) {
                const uid = res.data.user && res.data.user.id;
                const uid_str = uid.toString();
                if (uid != 0 && uid != undefined) {
                    // 清除这个cookie，因为端外切换账号，手机账号切换埋点可以正常上报到登录的uid账号上，但是如果切换第三方登录，微信，qq，要清除cookie里上一个账号的信息，否则会导致埋点上报到上一个账号下
                    tools.clearAllCookie();
                    // 使用login替代identify
                    kksa.login(uid_str || "");
                    // kksa.identify(uid_str);
                }
            }
        });
    }
}

export default function (event = "", prototype = {}) {		
    prototype = {		
        ...common_default,		
        ...prototype,		
        CurrentPlatform: returnTrackPlatform()		
    };
    doTrack(event, prototype);
}


// WEBPACK FOOTER //
// ./src/pages/native/pay/vip/link_vip_multiple/js/track.js